import {VideoSlideGameTitleDefaultBox} from "./video-slide-game-title-default.box";

export const VideoSlideGameTitleBox = VideoSlideGameTitleDefaultBox;